/**
 * Constants and configuration for the Gestionale application
 */

// Status configuration for cases
// 28/06/2026 — Rinominato "Completata" → "Conclusa" (richiesta utente:
// nomenclatura più ortodossa per gestione studio). Rimosso "Archiviata"
// (duplicato semantico di Conclusa, nessuna pratica esistente ne faceva
// uso; migration backend gestisce eventuali record legacy).
export const statusConfig = {
  "Nuova richiesta": { color: "bg-blue-100 text-blue-800", icon: "FileText", borderColor: "#3b82f6" },
  "Aperta": { color: "bg-blue-50 text-blue-700", icon: "FolderOpen", borderColor: "#60a5fa" },
  "In lavorazione": { color: "bg-yellow-100 text-yellow-800", icon: "Clock", borderColor: "#eab308" },
  "In attesa documenti": { color: "bg-orange-100 text-orange-800", icon: "FileQuestion", borderColor: "#f97316" },
  "Conclusa": { color: "bg-green-100 text-green-800", icon: "CheckCircle", borderColor: "#22c55e" },
  "Sospesa": { color: "bg-red-100 text-red-800", icon: "PauseCircle", borderColor: "#ef4444" },
};

// Priority configuration
export const priorityConfig = {
  "Alta": { color: "bg-red-100 text-red-800", icon: "AlertTriangle" },
  "Media": { color: "bg-yellow-100 text-yellow-800", icon: "Minus" },
  "Bassa": { color: "bg-green-100 text-green-800", icon: "ArrowDown" },
};

// Invoice status configuration
export const invoiceStatusConfig = {
  "Bozza": { color: "bg-gray-100 text-gray-800" },
  "Emessa": { color: "bg-blue-100 text-blue-800" },
  "Inviata": { color: "bg-purple-100 text-purple-800" },
  "Pagata": { color: "bg-green-100 text-green-800" },
  "Scaduta": { color: "bg-red-100 text-red-800" },
};

// Payment status configuration
export const paymentStatusConfig = {
  "Da pagare": { color: "bg-yellow-100 text-yellow-800" },
  "Parziale": { color: "bg-orange-100 text-orange-800" },
  "Pagata": { color: "bg-green-100 text-green-800" },
};

// Deadline urgency configuration
export const deadlineUrgencyConfig = {
  overdue: { color: "red", label: "Scaduta" },
  critical: { color: "red", label: "Critica" },
  warning: { color: "orange", label: "Attenzione" },
  normal: { color: "green", label: "OK" },
};

// Deadline rules by practice area
export const deadlineRules = {
  "Assunzione": [
    { name: "Comunicazione UniLav", days: 1, priority: "Alta" },
    { name: "Contratto di lavoro", days: 3, priority: "Alta" },
    { name: "Informativa privacy", days: 5, priority: "Media" },
    { name: "Visita medica", days: 10, priority: "Media" },
    { name: "Formazione sicurezza", days: 30, priority: "Media" },
  ],
  "Licenziamento": [
    { name: "Lettera di licenziamento", days: 1, priority: "Alta" },
    { name: "Comunicazione UniLav cessazione", days: 5, priority: "Alta" },
    { name: "Calcolo TFR", days: 10, priority: "Media" },
    { name: "Certificazione unica", days: 30, priority: "Media" },
  ],
  "Malattia": [
    { name: "Verifica certificato INPS", days: 1, priority: "Alta" },
    { name: "Comunicazione azienda", days: 2, priority: "Alta" },
    { name: "Calcolo indennità", days: 5, priority: "Media" },
  ],
  "Infortunio": [
    { name: "Denuncia INAIL", days: 2, priority: "Alta" },
    { name: "Comunicazione PS", days: 1, priority: "Alta" },
    { name: "Documentazione medica", days: 5, priority: "Media" },
    { name: "Follow-up INAIL", days: 30, priority: "Media" },
  ],
  "Maternità": [
    { name: "Domanda INPS", days: 7, priority: "Alta" },
    { name: "Comunicazione congedo", days: 14, priority: "Media" },
    { name: "Calcolo indennità", days: 20, priority: "Media" },
  ],
  "Trasformazione contratto": [
    { name: "Comunicazione UniLav", days: 5, priority: "Alta" },
    { name: "Nuovo contratto", days: 7, priority: "Alta" },
    { name: "Adeguamento busta paga", days: 10, priority: "Media" },
  ],
  "Vertenza": [
    { name: "Analisi richiesta", days: 3, priority: "Alta" },
    { name: "Raccolta documentazione", days: 7, priority: "Alta" },
    { name: "Risposta formale", days: 14, priority: "Alta" },
    { name: "Eventuale conciliazione", days: 30, priority: "Media" },
  ],
  "Consulenza": [
    { name: "Analisi richiesta", days: 3, priority: "Media" },
    { name: "Preparazione risposta", days: 7, priority: "Media" },
  ],
};

// Document templates
export const documentTemplates = {
  "Assunzione": ["Contratto di lavoro", "Lettera di assunzione", "Modulo privacy", "Documento identità", "Codice fiscale"],
  "Licenziamento": ["Lettera di licenziamento", "Dimissioni", "Preavviso", "Liberatoria"],
  "Malattia": ["Certificato medico INPS", "Comunicazione assenza"],
  "Infortunio": ["Certificato medico", "Denuncia INAIL", "Testimonianze"],
  "Maternità": ["Certificato gravidanza", "Domanda congedo", "Certificato nascita"],
  "Consulenza": ["Documentazione varia"],
};

// Status options for forms
// 28/06/2026 — Rinominato "Completata" → "Conclusa", rimosso "Archiviata"
// (vedi statusConfig sopra).
export const statusOptions = [
  "Nuova richiesta",
  "Aperta",
  "In lavorazione",
  "In attesa documenti",
  "Conclusa",
  "Sospesa"
];

// Priority options for forms
export const priorityOptions = ["Alta", "Media", "Bassa"];

// Channel options for forms
export const channelOptions = ["Email", "Telefono", "Di persona", "PEC", "Altro"];

// Client type options
export const clientTypeOptions = ["Privato", "Azienda", "Ente Pubblico", "Altro"];

// Invoice status options
export const invoiceStatusOptions = ["Bozza", "Emessa", "Inviata", "Pagata", "Scaduta"];

// Payment method options
export const paymentMethodOptions = ["Bonifico", "Contanti", "Assegno", "Carta", "Altro"];
